// extracted by mini-css-extract-plugin
module.exports = {"component":"style_component__wM9_N","area-disclaimer":"style_area-disclaimer__ulKfq","courtesy":"style_courtesy__TZKTH","disclaimer":"style_disclaimer__C01zr"};